import { ThemeDocSchema } from '../schemas/theme.js';
/**
 * The theme every event starts on, and the one "Reset to default" restores.
 *
 * Mirrors SILVER_SLATE_THEME in backend/src/domain/business_process/theming —
 * the server serves this to any event that has never saved a theme, so the two
 * must stay identical or resetting would hand the organiser something the API
 * never called the default. A backend source file cannot import this package
 * (perf.yml and zap.yml build the backend without building shared), so
 * backend/tests/contracts.test.ts asserts the two copies match.
 */
export const DEFAULT_THEME = ThemeDocSchema.parse({
    version: 1,
    name: 'Silver Slate',
    light: {
        primary: '#1E2A36',
        onPrimary: '#FFFFFF',
        primaryContainer: '#E5E9EE',
        secondary: '#9C8A6E',
        background: '#F7F7F5',
        surface: '#FFFFFF',
        onSurface: '#1E2A36',
        error: '#B3261E',
        success: '#256C4A',
        warning: '#A8650F',
    },
    dark: {
        primary: '#E5E9EE',
        onPrimary: '#1E2A36',
        primaryContainer: '#2E3B4A',
        secondary: '#C8B898',
        background: '#0E1620',
        surface: '#1A2330',
        onSurface: '#F7F7F5',
        error: '#FFB4AB',
        success: '#7BD3A8',
        warning: '#FFD0A0',
    },
    typography: { headingFamily: 'Fraunces', bodyFamily: 'Inter', scale: 'comfortable' },
    shape: { cornerRadius: 12, density: 'regular' },
});
/** Key order varies with how a doc was built, so compare on sorted keys. */
const stable = (value) => JSON.stringify(value, (_key, v) => v && typeof v === 'object' && !Array.isArray(v)
    ? Object.fromEntries(Object.entries(v).sort(([a], [b]) => a < b ? -1 : a > b ? 1 : 0))
    : v);
export const themesEqual = (a, b) => stable(a) === stable(b);
/** Same comparison, for one palette — "is this dark block still ours?" */
export const tokensEqual = (a, b) => a !== undefined && b !== undefined && stable(a) === stable(b);
/** Whether this theme is untouched — what the reset button keys off. */
export const isDefaultTheme = (theme) => themesEqual(theme, DEFAULT_THEME);
//# sourceMappingURL=default_theme.js.map